import React, { useState, useEffect } from 'react';
import { supabase } from '../../config/supabase';

// ── تحويل روابط الفيديو لـ embed (Vimeo / YouTube / ملف Drive) ──
// بترجّع null لو الرابط مش قابل للتشغيل المباشر (فولدر Drive أو رابط غريب)
const getEmbedUrl = (url) => {
  if (!url) return null;
  // Vimeo
  const vimeo = url.match(/vimeo\.com\/(?:reviews\/[^/]+\/videos\/|video\/|)(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  // YouTube
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?rel=0`;
  // Google Drive — ملف فقط (مش فولدر)
  const driveFile = url.match(/drive\.google\.com\/file\/d\/([^/]+)/);
  if (driveFile) return `https://drive.google.com/file/d/${driveFile[1]}/preview`;
  const driveOpen = url.match(/drive\.google\.com\/open\?id=([^&]+)/);
  if (driveOpen) return `https://drive.google.com/file/d/${driveOpen[1]}/preview`;
  // فولدر Drive أو أي رابط تاني → مش قابل للتشغيل
  if (url.includes('drive.google.com')) return null;
  return null;
};

const getThumb = (url) => {
  const yt = url?.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
  if (yt) return `https://img.youtube.com/vi/${yt[1]}/mqdefault.jpg`;
  return null;
};

// واتساب ولا رابط دفع/عادي؟
const isWhatsApp = (u) => !!u && /(wa\.me|whatsapp\.com|api\.whatsapp)/i.test(u);

// ── عنصر واحد في الشريط (مضغوط) ───────────────────────
function SidebarItem({ item, lang, onOpen }) {
  const title = lang === 'ar' ? item.title_ar : (item.title_en || item.title_ar);
  const thumb = item.thumb_url || getThumb(item.content);
  const isVideo = item.type === 'video';
  const isImage = item.type === 'image';
  const isText  = item.type === 'text';

  // نص: يتعرض inline + زرار CTA لو فيه رابط
  if (isText) {
    return (
      <div style={{ padding: '8px', borderRadius: '10px' }}>
        {title && <p style={{ margin: '0 0 4px', fontSize: '12px', fontWeight: '700', color: 'rgba(255,255,255,0.92)' }}>{title}</p>}
        {item.content && <p style={{ margin: 0, fontSize: '11px', color: 'rgba(255,255,255,0.65)', lineHeight: '1.6', whiteSpace: 'pre-line' }}>{item.content}</p>}
        <CTAButtons item={item} />
      </div>
    );
  }

  // فيديو / صورة: مضغوط، الكليك يفتح المودال
  return (
    <div onClick={() => onOpen(item)}
      style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', padding: '8px', borderRadius: '10px', cursor: 'pointer', transition: 'background 0.15s' }}
      onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.07)'}
      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
    >
      <div style={{ flexShrink: 0, width: '64px', height: '44px', borderRadius: '6px', overflow: 'hidden', position: 'relative', background: '#0b1230', border: '1px solid rgba(255,255,255,0.08)' }}>
        {thumb
          ? <img src={thumb} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: 'rgba(255,255,255,0.7)' }}>{isVideo ? '▶' : '🖼️'}</div>}
        {isVideo && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.4)' }}>
            <div style={{ width: '20px', height: '20px', background: 'rgba(255,255,255,0.92)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '8px', paddingLeft: '1px', color: '#0b1230' }}>▶</div>
          </div>
        )}
        {item.duration && (
          <div style={{ position: 'absolute', bottom: '2px', left: '2px', background: 'rgba(0,0,0,0.8)', color: '#fff', fontSize: '9px', padding: '1px 4px', borderRadius: '3px' }}>{item.duration}</div>
        )}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && (
          <p style={{ margin: 0, fontSize: '11px', fontWeight: '600', color: 'rgba(255,255,255,0.92)', lineHeight: '1.4', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{title}</p>
        )}
        {item.link_url && (
          <span style={{ fontSize: '10px', color: '#fb923c', fontWeight: '700' }}>اضغط للتفاصيل ←</span>
        )}
      </div>
    </div>
  );
}

// ستايل زرار الـ CTA
function ctaStyle(whatsapp, block) {
  return {
    marginTop: '8px',
    display: block ? 'block' : 'inline-block',
    width: block ? '100%' : 'auto',
    padding: '9px 14px',
    background: whatsapp ? 'linear-gradient(135deg,#22c55e,#16a34a)' : 'linear-gradient(135deg,#f97316,#fb923c)',
    color: '#fff', border: 'none', borderRadius: '10px',
    fontSize: '13px', fontWeight: '800', cursor: 'pointer',
    fontFamily: "'Tajawal', sans-serif",
    boxShadow: whatsapp ? '0 8px 20px rgba(34,197,94,0.35)' : '0 8px 20px rgba(249,115,22,0.35)',
  };
}

// زرّين التحويل: واتساب (link_url) + دفع بالفيزا (pay_url)
function CTAButtons({ item }) {
  const wa  = item.link_url;
  const pay = item.pay_url;
  if (!wa && !pay) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '8px' }}>
      {wa && (
        <button onClick={() => window.open(wa, '_blank')} style={ctaStyle(true, true)}>
          💬 تواصل عبر واتساب
        </button>
      )}
      {pay && (
        <button onClick={() => window.open(pay, '_blank')} style={ctaStyle(false, true)}>
          💳 ادفع بالفيزا
        </button>
      )}
    </div>
  );
}

// ── مودال العرض: فيديو + شرح + زرار تحويل ─────────────
function OfferModal({ item, lang, onClose }) {
  const title = lang === 'ar' ? item.title_ar : (item.title_en || item.title_ar);
  const desc  = lang === 'ar' ? item.description_ar : (item.description_en || item.description_ar);
  const isVideo = item.type === 'video';
  const isImage = item.type === 'image';
  const embed = isVideo ? getEmbedUrl(item.content) : null;

  return (
    <div onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(3,6,20,0.82)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', backdropFilter: 'blur(4px)' }}>
      <div onClick={e => e.stopPropagation()}
        style={{ width: '100%', maxWidth: '720px', maxHeight: '90vh', overflowY: 'auto', background: 'linear-gradient(135deg,#0b1230,#141a44)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '18px', boxShadow: '0 30px 80px rgba(0,0,0,0.6)', fontFamily: "'Tajawal', sans-serif", direction: lang === 'ar' ? 'rtl' : 'ltr' }}>
        {/* هيدر */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <span style={{ color: '#fff', fontSize: '16px', fontWeight: '800' }}>{title || 'عرض'}</span>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.08)', border: 'none', color: '#fff', fontSize: '16px', cursor: 'pointer', width: '32px', height: '32px', borderRadius: '8px' }}>✕</button>
        </div>

        <div style={{ padding: '18px' }}>
          {/* الوسائط */}
          {isVideo && embed && (
            <div style={{ position: 'relative', paddingBottom: '56.25%', borderRadius: '12px', overflow: 'hidden', marginBottom: '16px', background: '#000' }}>
              <iframe src={embed.includes('vimeo') || embed.includes('youtube') ? embed + (embed.includes('?') ? '&autoplay=1' : '?autoplay=1') : embed}
                style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          )}

          {/* فيديو لكن الرابط مش قابل للتشغيل (فولدر Drive مثلاً) */}
          {isVideo && !embed && (
            <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px dashed rgba(255,255,255,0.18)', borderRadius: '12px', padding: '26px 18px', textAlign: 'center', marginBottom: '16px' }}>
              <div style={{ fontSize: '30px', marginBottom: '8px' }}>🎬</div>
              <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '13px', margin: '0 0 12px', lineHeight: '1.7' }}>
                الفيديو مش قابل للتشغيل المباشر من الرابط ده.<br />
                استخدم رابط <b>Vimeo</b> أو <b>YouTube</b> أو رابط <b>ملف</b> Google Drive (مش فولدر).
              </p>
              {item.content && (
                <button onClick={() => window.open(item.content, '_blank')}
                  style={{ padding: '9px 18px', background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '10px', fontSize: '13px', cursor: 'pointer', fontWeight: '700', fontFamily: "'Tajawal', sans-serif" }}>
                  افتح الرابط في تاب جديد ↗
                </button>
              )}
            </div>
          )}

          {isImage && item.content && (
            <img src={item.content} alt={title || ''} style={{ width: '100%', borderRadius: '12px', marginBottom: '16px', display: 'block' }} />
          )}

          {/* الشرح */}
          {desc && (
            <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '14px', lineHeight: '2', margin: '0 0 18px', whiteSpace: 'pre-line' }}>{desc}</p>
          )}

          {/* زرارين التحويل */}
          <CTAButtons item={item} />
        </div>
      </div>
    </div>
  );
}

// ── قائمة تشغيل واحدة ────────────────────────────────
function PlaylistCard({ playlist, lang, onOpen, index = 0 }) {
  const [items,    setItems]    = useState([]);
  const [expanded, setExpanded] = useState(true);
  const name = lang === 'ar' ? playlist.name_ar : (playlist.name_en || playlist.name_ar);

  useEffect(() => {
    supabase.from('sidebar_items').select('*')
      .eq('playlist_id', playlist.id).eq('is_active', true)
      .order('order_num')
      .then(({ data }) => { if (data) setItems(data); });
  }, [playlist.id]);

  return (
    <div style={{
      background: 'rgba(255,255,255,0.05)', borderRadius: '14px', overflow: 'hidden',
      boxShadow: '0 10px 30px rgba(0,0,0,0.3)', marginBottom: '12px',
      border: '1px solid rgba(255,255,255,0.1)',
      backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)',
      fontFamily: "'Tajawal', sans-serif",
      animation: 'cardRise .5s cubic-bezier(.22,1,.36,1) both', animationDelay: `${index * 0.08}s`,
    }}>
      <div onClick={() => setExpanded(x => !x)}
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', cursor: 'pointer', background: 'linear-gradient(135deg,rgba(249,115,22,0.14),rgba(249,115,22,0.04))', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontSize: '16px' }}>{playlist.icon}</span>
          <span style={{ fontSize: '12px', fontWeight: 'bold', color: 'rgba(255,255,255,0.95)' }}>{name}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontSize: '10px', color: '#fb923c', background: 'rgba(249,115,22,0.18)', padding: '1px 6px', borderRadius: '10px', fontWeight: '700' }}>{items.length}</span>
          <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.55)', transition: 'transform 0.2s', display: 'inline-block', transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>▼</span>
        </div>
      </div>

      {expanded && items.length > 0 && (
        <div style={{ padding: '6px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          {items.map(item => (
            <SidebarItem key={item.id} item={item} lang={lang} onOpen={onOpen} />
          ))}
        </div>
      )}

      {expanded && items.length === 0 && (
        <div style={{ padding: '12px', textAlign: 'center', fontSize: '11px', color: 'rgba(255,255,255,0.45)' }}>لا توجد عناصر بعد</div>
      )}
    </div>
  );
}

// ── المكوّن الرئيسي ─────────────────────────────────────
export default function SidebarPanels({ side, lang }) {
  const [playlists,  setPlaylists]  = useState([]);
  const [openItem,   setOpenItem]   = useState(null);

  useEffect(() => {
    supabase.from('sidebar_playlists').select('*')
      .eq('side', side).eq('is_active', true)
      .order('order_num')
      .then(({ data }) => { if (data) setPlaylists(data); });
  }, [side]);

  if (playlists.length === 0) return null;

  return (
    <>
      <div style={{ width: '190px', flexShrink: 0 }}>
        {playlists.map((pl, i) => (
          <PlaylistCard key={pl.id} playlist={pl} lang={lang} onOpen={setOpenItem} index={i} />
        ))}
      </div>
      {openItem && <OfferModal item={openItem} lang={lang} onClose={() => setOpenItem(null)} />}
    </>
  );
}
